import { render, staticRenderFns } from "./TagsManager.vue?vue&type=template&id=dff12b66&scoped=true&"
import script from "./TagsManager.vue?vue&type=script&lang=js&"
export * from "./TagsManager.vue?vue&type=script&lang=js&"
import style0 from "./TagsManager.vue?vue&type=style&index=0&id=dff12b66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dff12b66",
  null
  
)

export default component.exports